




























import Component from "vue-class-component";
import ViewList from "@/views/List.vue";
import CompetitorList from "@/components/competitor/List.vue";
import _ from "lodash";
import { Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as Constants from "@/Constants";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import KeywordSearch from "@/components/forms/search/KeywordSearch.vue";

const components = {
    CompetitorList,
    SelectSearch,
    KeywordSearch,
};

@Component({ components })
export default class List extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    private optionsStatus = Constants.optionsCompetitorStatus;
    protected filters: object = { type: "store", competitors: true };

    public created(): void {
        if (this.currentOwnerUuid) {
            _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
        }
    }

    @Watch("currentOwnerUuid") public updateOwnerUuid(): void {
        if (this.currentOwnerUuid) {
            _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
        }
    }

    public updateFilter(filter: object): void {
        this.filters = Object.assign({}, this.filters, filter);
    }
}
